import { contextReducer, documentReducer, referenceReducer } from 'metrix-common3';
import { workflowReducer } from 'metrix-workflow3';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import agentReducer from '../reducers/agent';
import brokerCompanySettingsReducer from '../reducers/brokerCompanySettings';
import brokerCompanySignupReducer from '../reducers/brokerCompanySignup';
import clientReducer from '../reducers/client';
import clientCompanyReducer from '../reducers/clientCompany';
import confirmationReducer from '../reducers/confirmation';
import paymentReducer from '../reducers/payment';
import policyReducer from '../reducers/policy';
import productReducer from '../reducers/product';
import securityReducer from '../reducers/security';
import storefrontReducer from '../reducers/storefront';
import templateReducer from '../reducers/template';
import userReducer from '../reducers/user';

export default function configureStore(initialState = {}) {
    const reducers = {
        context: contextReducer,
        security: securityReducer,
        storefront: storefrontReducer,
        workflow: workflowReducer,
        policy: policyReducer,
        product: productReducer,
        products: productReducer,
        templateConfig: templateReducer,
        agent: agentReducer,
        clientCompany: clientCompanyReducer,
        client: clientReducer,
        reference: referenceReducer,
        document: documentReducer,
        brokerCompanySignup: brokerCompanySignupReducer,
        brokerCompanySettings: brokerCompanySettingsReducer,
        payment: paymentReducer,
        user: userReducer,
        confirmation: confirmationReducer,
    };

    const sagaMiddleware = createSagaMiddleware();

    const middleware = [sagaMiddleware];

    const enhancers = [];
    const isDevelopment = import.meta.env.MODE === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const rootReducer = combineReducers({
        ...reducers,
    });

    const store = createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));

    store.injectedReducers = {};
    store.runSaga = sagaMiddleware.run;
    store.injectedSagas = {};

    return store;
}
